import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {ReportRequest} from '../../../kitchen/shared/domain/report/report-request.model';
import {ReportResponse} from '../../../kitchen/shared/domain/report/report-response.model';
import {ReportType} from '../../../kitchen/shared/domain/report/report-type.enum';

@Injectable()
export class ReportRunnerService {

  constructor(private httpClient: HttpClient) {
  }

  kitchenReport(request: ReportRequest): Observable<ReportResponse> {
    return this.httpClient.post<ReportResponse>(`${environment.serviceUrl}/ad-stats/report`, request);
  }

  publisherReport(request: ReportRequest): Observable<ReportResponse> {
    return this.httpClient.post<ReportResponse>(`${environment.publisherApiUrl}/report`, request);
  }

  publisherPromoReport(request: ReportRequest): Observable<ReportResponse> {
    return this.httpClient.post<ReportResponse>(`${environment.publisherApiUrl}/promo-report`, request);
  }
}
